import { useState } from 'react';
import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import GameCard from '@/components/feature/GameCard';
import { games } from '@/data/games';

export default function AllGames() {
  const [search, setSearch] = useState('');

  const filteredGames = search.trim()
    ? games.filter((g) => g.name.toLowerCase().includes(search.toLowerCase()))
    : games;

  return (
    <>
      <SEOHead
        title="All Yono Games – Browse Every Yono Game and App for Android"
        description="Browse our complete directory of 90 Yono Games. Find rummy games, slot games, card games, and more. Download APKs for every Yono app listed on our platform."
        keywords="All Yono Games, Yono Games List, Yono Apps Directory, Android Games, Rummy, Slots, Yono Download"
      />

      <Header />

      <main>
        <div className="px-4 py-5">
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-1">
            All Yono Games
          </h1>
          <p className="text-foreground-500 text-[12px] leading-relaxed mb-4">
            Browse all 90 Yono games and apps in our directory. Find your next favorite game and download the APK directly.
          </p>

          <div className="relative mb-4">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search games..."
              className="w-full pl-9 pr-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-[13px] text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
          </div>

          {filteredGames.length === 0 ? (
            <div className="text-center py-16">
              <p className="text-foreground-500 text-sm">No games found for "{search}"</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-2">
              {filteredGames.map((game) => (
                <GameCard key={game.id} game={game} />
              ))}
            </div>
          )}

          <p className="text-foreground-400 text-[10px] leading-relaxed mt-4 text-center">
            Bonus amounts, deposit requirements and withdrawal terms may change. Review the current offer terms before registering or depositing.
          </p>
        </div>
      </main>

      <Footer />
    </>
  );
}